<template>
  <div class="dtreport__report__view">
    <div class="reports__subheader">
      <year-month-panel
        @year="(value) => setYear(value)"
        @month="(value) => setMonth(value)"
      >
      </year-month-panel>

      <employees-panel
        @employeeNumberChanged="(value) => setEmployeeNumber(value)"
        @employeeId="(value) => setEmployeeId(value)"
        @employeeName="(value) => setEmployeeName(value)"
        :employeeNumber="employeeNumber"
        v-if="isAdmin"
      >
      </employees-panel>

      <submit-panel @submit="performLookup"> </submit-panel>
      <div class="button-secondary" v-if="employeeNumber && isAdmin">
        <button
          class="button is-secondary"
          @click="setNewUserDriveData(currentUser)"
        >
          Ny
        </button>
      </div>
    </div>
    <h3 style="text-align: left; margin-left: 12px;font-weight: bold;">
      DT rapport
    </h3>
    <b-table :v-if="report" :data="report" :loading="loading" striped>
      <b-table-column
        field="createdDate"
        label="Dato"
        v-slot="props"
        width="100"
      >
          {{ props.row.createdDate ? formatDate(props.row.createdDate) : "" }}
      </b-table-column>
      <b-table-column
        field="typeStringified"
        label="Type"
        v-slot="props"
        width="80"
      >
          {{ props.row.typeStringified ? props.row.typeStringified : "" }}
      </b-table-column>
      <b-table-column
        field="chr"
        label="chr"
        v-slot="props"
        width="80"
      >
          {{ props.row.chr ? props.row.chr : "" }}
      </b-table-column>
      <b-table-column
        field="totalImposed"
        label="Antal ilagte emb."
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.totalImposed ? props.row.totalImposed : "" }}
      </b-table-column>
      <b-table-column
        field="totalPreliminaryInvestigations"
        label="Antal FU."
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.totalPreliminaryInvestigations ? props.row.totalPreliminaryInvestigations : "" }}
      </b-table-column>
      <!-- <b-table-column
        field="totalPreliminaryInvestigationsDonor"
        label="Antal FU. doner"
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.totalPreliminaryInvestigationsDonor ? props.row.totalPreliminaryInvestigationsDonor : "" }}
      </b-table-column> -->

      <b-table-column
        field="vainVisits"
        label="Forgæves besøg"
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.vainVisits ? props.row.vainVisits : "" }}
      </b-table-column>
      <b-table-column
        field="vgProject"
        label="VGProjekt"
        v-slot="props"
        width="100"
      >
        <div class="text-left" :style="props.row.style ? props.row.style : {}">
          {{ props.row.vgProject ? "Ja" : "" }}
        </div>
      </b-table-column>
      <b-table-column
        field="onDayOff"
        label="På fridag"
        v-slot="props"
        width="100"
      >
        <div class="text-left" :style="props.row.style ? props.row.style : {}">
          {{ props.row.onDayOff ? "Ja" : "" }}
        </div>
      </b-table-column>
      <b-table-column
        field="timeInMinutes"
        label="Minutter"
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.timeInMinutes ? props.row.timeInMinutes : "" }}
      </b-table-column>
      <b-table-column field="days" label="Dage" v-slot="props" width="100" numeric>
          {{ props.row.days ? props.row.days : "" }}
      </b-table-column>
      <b-table-column
        field="distance"
        label="Distance"
        v-slot="props"
        width="100"
        numeric
      >
          {{ props.row.distance ? props.row.distance : ""  }}
      </b-table-column>

      <b-table-column
        field="isHoliday"
        label="S/H"
        v-slot="props"
        width="150"
      >
        <div class="text-left">
          <b-checkbox
            :style="props.row.style ? props.row.style : {}"
            :value="props.row.isHoliday"
            :disabled="true"
          >
          </b-checkbox>
        </div>
      </b-table-column>

      <b-table-column field="edit" label="Rediger" v-slot="props" width="150" :visible="isAdmin">
        <div class="text-left">
          <b-button
            class="text-left"
            :style="props.row.style ? props.row.style : {}"
            @click="setSelectedUserDriveData(props.row)"
          >
            {{ isAdmin ? "Rediger" : "Vis mere" }}
          </b-button>
        </div>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import YearMonthPanel from "@/components/report/YearMonthPanel.vue";
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";
import moment, { ISO_8601 } from "moment";

export default {
  name: "dt-report",
  components: { YearMonthPanel, EmployeesPanel, SubmitPanel },
  data: () => ({}),
  mounted() {
    if (!this.isAdmin) {
      this.setEmployeeId(this.currentUser.id);
      this.setEmployeeNumber(this.currentUser.number);
      this.setEmployeeName(this.currentUser.name);
    }
  },
  methods: {
    ...mapActions("dtReportStore", [
      "performLookup",
      "setYear",
      "setMonth",
      "setEmployeeNumber",
      "setSelectedUserDriveData",
      "setNewUserDriveData",
      "setEmployeeName",
      "setEmployeeId",
    ]),
    formatDate(date) {
      return moment(date).format("DD/MM-YYYY");
    },
    formatTime(date) {
      return moment(date).format("hh:mm");
    },
  },
  computed: {
    ...mapGetters("dtReportStore", [
      "report",
      "employeeNumber",
      "loading",
      "year",
      "month",
    ]),
    ...mapGetters(["currentUser", "isAdmin"]),
  },
};
</script>
<style scoped>
.text-left {
  text-align: left !important;
}
.button-secondary {
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;
  padding-left: 4px;
  font-weight: 400;
}

.is-secondary {
  height: 28px !important;
  border: 1px solid transparent;
}
</style>
